import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import UserLogin from './pages/user-login';
import AIPredictionsDetail from './pages/ai-predictions-detail';
import PortfolioTracker from './pages/portfolio-tracker';
import UserRegistration from './pages/user-registration';
import TradingSignals from './pages/trading-signals';
import SubscriptionManagement from './pages/subscription-management';
import MarketAnalysis from './pages/market-analysis';
import TradingDashboard from './pages/trading-dashboard';
import CheckoutPage from './pages/checkout';
import TaxCalculator from './pages/tax-calculator';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <ScrollToTop />
        <RouterRoutes>
          <Route path="/" element={<TradingDashboard />} />
          <Route path="/trading-dashboard" element={<TradingDashboard />} />
          <Route path="/ai-predictions-detail" element={<AIPredictionsDetail />} />
          <Route path="/portfolio-tracker" element={<PortfolioTracker />} />
          <Route path="/tax-calculator" element={<TaxCalculator />} />
          <Route path="/user-login" element={<UserLogin />} />
          <Route path="/user-registration" element={<UserRegistration />} />
          <Route path="/trading-signals" element={<TradingSignals />} />
          <Route path="/subscription-management" element={<SubscriptionManagement />} />
          <Route path="/market-analysis" element={<MarketAnalysis />} />
          <Route path="/checkout" element={<CheckoutPage />} />
          <Route path="*" element={<NotFound />} />
        </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;